import { MdErrorOutline } from "react-icons/md";
import Button from "components/button/Button";

/**
 * Failed-fetch placeholder with an optional retry.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.title="Something went wrong"]
 * @param {"h1"|"h2"|"h3"|"h4"} [props.titleAs="h3"] Heading element; use "h1" on standalone screens with no other h1.
 * @param {React.ReactNode} [props.message] Detail, e.g. `getApiErrorMessage(err)`.
 * @param {() => void} [props.onRetry] Renders a Retry button when provided.
 * @param {string} [props.retryLabel="Try Again"]
 * @param {string} [props.className]
 */
const ErrorState = ({
  title = "Something went wrong",
  titleAs: TitleTag = "h3",
  message,
  onRetry,
  retryLabel = "Try Again",
  className = "",
}) => (
  <div
    role="alert"
    className={`flex flex-col items-center justify-center px-4 py-12 text-center ${className}`.trim()}
  >
    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-danger-subtle text-danger-fg">
      <MdErrorOutline aria-hidden="true" className="h-6 w-6" />
    </div>
    <TitleTag className="text-heading">{title}</TitleTag>
    {message && <p className="mt-1 max-w-md text-sm text-fg-muted">{message}</p>}
    {onRetry && (
      <Button variant="secondary" onClick={onRetry} className="mt-5">
        {retryLabel}
      </Button>
    )}
  </div>
);

export default ErrorState;
